var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InvoicePaxesTable',{attrs:{"contractList":_vm.contractList,"loading":_vm.loadingContractList}})
}
var staticRenderFns = []

export { render, staticRenderFns }